import React from 'react'
import { Dejargonator, Icon } from '@ally/metronome-ui'
import { muiHelpOutline } from '@ally/metronome-icons'
import { TextBodyOverride } from '../../../Shared/MetronomeOverrides'

const TotalBalanceDejarg: React.FC = () => {
  return (
    <Dejargonator
      trigger={{
        ariaLabel: 'Select to learn more about your Total',
        variant: 'icon',
        content: <Icon icon={muiHelpOutline} size="md" fill="bluesuedeshoes" />,
      }}
      popoverAriaLabel="Total"
      body={
        <TextBodyOverride tag="p" size="sm" color="gray-400">
          Your{' '}
          <TextBodyOverride tag="span" size="sm" weight="bold" color="gray-400">
            Total
          </TextBodyOverride>{' '}
          is the sum of the available balances of your Ally Bank Money Market,
          Online Savings and Interest Checking accounts; the current balance of
          your Ally Bank CDs, and the account value for your Ally Invest
          accounts.
        </TextBodyOverride>
      }
    />
  )
}

export default TotalBalanceDejarg
